export default __webpack_public_path__ + "static/media/svg-2.2e36eee2.svg";